import styled from "styled-components";
import { PrimaryButton } from "../../../../Buttons/PrimaryButton/PrimaryButton";

export const CancelButtonContainer = styled(PrimaryButton)`
  @media screen and (max-width: 600px) {
    width: 147px;
    height: 45px;
  }
`;